import * as yup from 'yup'

import { isValidCnpj, isValidCpf } from '../../util/documentValidator'
import { getMessage } from '../../util/IntlMessages'
import { documentTypes } from '../../util/enums'

export const UpdateFormValidations = (isAdmin) =>
  yup.object().shape({
    name: yup
      .string()
      .matches(/[a-zA-Z]+/g, 'Preencha um nome válido')
      .max(60)
      .typeError('must be string')
      .required(getMessage('isRequired', getMessage('memberName'))),
    phoneNumber: yup.string().max(20).typeError('must be string').nullable(),
    emailAddress: yup
      .string()
      .max(60)
      .typeError('must be string')
      .email(getMessage('isInvalidEmail'))
      .required(getMessage('isRequired', getMessage('emailAddress'))),
    dummy: yup.string(), // Used to organization dynamic validations
    organizations: yup
      .array()
      .of(yup.number())
      .when('dummy', {
        is: () => isAdmin,
        then: (schema) =>
          schema
            .min(1, getMessage('isRequired', getMessage('organization')))
            .required(getMessage('isRequired', getMessage('organization'))),
        otherwise: (schema) => schema.nullable()
      }),
    documentNumber: yup
      .string()
      .max(20)
      .required(getMessage('isRequired', getMessage('documentNumber')))
      .when('documentTypeId', (documentTypeId, schema) => {
        if (documentTypeId === documentTypes.CPF) {
          return schema.test('documentNumber', getMessage('cpfInvalid'), (value) => {
            const isValid = isValidCpf(value)
            return isValid
          })
        }

        if (documentTypeId === documentTypes.CNPJ) {
          return schema.test('documentNumber', getMessage('cnpjInvalid'), (value) => {
            const isValid = isValidCnpj(value)
            return isValid
          })
        }

        return schema
      }),
    documentTypeId: yup
      .string(getMessage('isRequired', getMessage('documentType')))
      .max(20)
      .required(getMessage('isRequired', getMessage('documentType'))),
    addressDescription: yup.string().max(60).typeError('must be string').nullable(),
    addressNumber: yup.string().max(10).typeError('must be string').nullable(),
    addressComplement: yup.string().max(60).typeError('must be string').nullable(),
    neighborhood: yup.string().max(60).typeError('must be string').nullable(),
    zipCode: yup.string().max(10).typeError('must be string').nullable(),
    memberTypeId: yup
      .number()
      .typeError('must be a valid id')
      .required(getMessage('isRequired', getMessage('memberTypes'))),
    regions: yup.array().of(yup.number()).min(1, getMessage('selectTheRegion')).required(getMessage('selectTheRegion')),
    profileId: yup
      .string()
      .nullable()
      .when('allowToLogin', (allowToLogin, schema) => {
        if (allowToLogin) {
          return schema.required(getMessage('isRequired', getMessage('profile')))
        }

        return schema
      })
  })

export const CreateFormValidations = (isAdmin) =>
  yup.object().shape({
    phoneNumber: yup.string().max(20).typeError('must be string').nullable(),
    emailAddress: yup
      .string()
      .max(60)
      .typeError('must be string')
      .email(getMessage('isInvalidEmail'))
      .required(getMessage('isRequired', getMessage('emailAddress')))
      .nullable(),
    dummy: yup.string(), // Used to organization dynamic validations
    organizations: yup
      .array()
      .of(yup.number())
      .when('dummy', {
        is: () => isAdmin,
        then: (schema) =>
          schema
            .min(1, getMessage('isRequired', getMessage('organization')))
            .required(getMessage('isRequired', getMessage('organization'))),
        otherwise: (schema) => schema.nullable()
      }),
    documentNumber: yup
      .string()
      .max(20)
      .required(getMessage('isRequired', getMessage('documentNumber')))
      .nullable()
      .when('documentTypeId', (documentTypeId, schema) => {
        switch (documentTypeId) {
          case documentTypes.CPF:
            return schema.test('documentNumber', getMessage('cpfInvalid'), (value) => isValidCpf(value))
          case documentTypes.CNPJ:
            return schema.test('documentNumber', getMessage('cnpjInvalid'), (value) => isValidCnpj(value))
          default:
            return schema
        }
      }),
    documentTypeId: yup
      .string(getMessage('isRequired', getMessage('documentType')))
      .max(20)
      .required(getMessage('isRequired', getMessage('documentType')))
      .nullable(),
    addressDescription: yup.string().max(60).typeError('must be string').nullable(),
    name: yup
      .string()
      .matches(/[a-zA-Z]+/g, 'Preencha um nome válido')
      .max(60)
      .typeError('must be string')
      .required(getMessage('isRequired', getMessage('memberName'))),
    addressNumber: yup.string().max(10).typeError('must be string').nullable(),
    addressComplement: yup.string().max(60).typeError('must be string').nullable(),
    neighborhood: yup.string().max(60).typeError('must be string').nullable(),
    zipCode: yup.string().max(10).typeError('must be string').nullable(),
    memberTypeId: yup
      .number()
      .typeError('must be a valid id')
      .required(getMessage('isRequired', getMessage('memberTypes')))
      .nullable(),
    regions: yup.array().of(yup.number()).min(1, getMessage('selectTheRegion')).required(getMessage('selectTheRegion')),
    profileId: yup
      .string()
      .nullable()
      .when('allowToLogin', (allowToLogin, schema) => {
        if (allowToLogin) {
          return schema.required(getMessage('isRequired', getMessage('profile')))
        }

        return schema.nullable()
      })
  })
